import { Box, keyframes } from '@mui/material'

const bounce = keyframes`
  0%, 80%, 100% { transform: scale(0); }
  40% { transform: scale(1); }
`

const TypingIndicator = () => (
  <Box sx={{ display: 'flex', gap: 0.5, p: 1.5, alignItems: 'center' }}>
    {[0, 1, 2].map((i) => (
      <Box
        key={i}
        sx={{
          width: 8,
          height: 8,
          borderRadius: '50%',
          bgcolor: 'grey.400',
          animation: `${bounce} 1.4s infinite ease-in-out both`,
          animationDelay: `${i * 0.16}s`,
        }}
      />
    ))}
  </Box>
)

export default TypingIndicator
